// extracted by mini-css-extract-plugin
module.exports = {"CheckoutSummary":"CheckoutSummary_CheckoutSummary__3PsXi","Center":"CheckoutSummary_Center__1N4Bl"};